module.exports = __webpack_public_path__ + "img/pexels-photo-1507510.ef81177c.jpg";